/**
 *
 * @module b-checkbox
 */

define( 'toolkit/b-checkbox/b-checkbox', [
	'toolkit/b-toolkit/b-toolkit'
], function (toolkit){
	'use strict';

	return toolkit.create('b-checkbox', {

		onRender: function() {
			this._initEvents();
			this._initElems();
		},

		init: function() {
			this.data.checked = this.data.checked || false;
			this._initEvents();
			this._initElems();

			return toolkit['b-toolkit'].fn.init.apply(this, arguments);
		},

		render: function() {
			this._initedElems = false;

			return toolkit['b-toolkit'].fn.render.apply(this, arguments);
		},

		/**
		 * Включает или выключает радио-группу.
		 * @param {boolean} state
		 * true – включает
		 * false – выключает
		 * @param {boolean} silent
		 * true – не эмитить событие
		 * false – эмитить событие
		 * @memberOf b-checkbox#
		 */
		toggle: function (state, silent) {
			this._checked = state;

			this.data.props = this.data.props || {};
			this.data.props.value = state ? 1 : 0;
			this.extendData({
				checked: state
			});

			this.__input.attr('disabled', !state);

			this.$el.toggleMod('checked', state);

			if (!silent) {
				this.emit('change', this._checked);
			}
		},

		_onTap: function (event) {
			event.preventDefault();

			if (this.data.disabled || this.hasMod('disabled')) {
				return;
			}

			var checked = !this._checked;

			this.toggle(checked, this._silent);
		},

		_initElems: function() {
			if (this._initedElems) {
				return;
			}

			this.__input = this.$('__input');

			if (this.__input.length) {
				this._initedElems = true;
			}
		},

		/**
		 * @desc инициалиация событий на дом элементы
		 * @private
		 * @memberOf b-checkbox#
		 */
		_initEvents: function(){
			this.$el.off(); // отписываемся, если уже подписались

			this.data.mods = this.data.mods || [];
			this._silent = this.data.mods.includes('silent');
			this._checked = this.data.checked;
			this.$el.on('tap', this._onTap.bind(this));
		},

		getValue: function() {
			return this.data.props.value;
		}

	});

});
